export function createSchemaDictionary(schemaJson) {
  const dictionary = {
    __order: [],
  };
  handleProperty(schemaJson.name, schemaJson, schemaJson.name);
  return dictionary;

  /////////////////////

  function handleProperties(recordName, xpath, properties, parent) {
    if (Object.keys(properties).length > 0) {
      dictionary.__order.push(recordName);
    }

    Object.keys(properties).forEach(key => {
      handleProperty(key, properties[key], `${xpath}.${key}`, parent);
    });
  }

  function handleProperty(key, schemaField, xpath, parent) {
    dictionary[xpath] = schemaField;
    if (!schemaField.use) {
      schemaField.use = (schemaField.type === 'array' && schemaField.minItems) || parent?.required?.includes?.(key) ? 'required' : 'optional';
    }
    handleProperties(key, xpath, schemaField.properties || schemaField.items?.properties || [], schemaField);
  }
}
